module.exports = __webpack_public_path__ + "static/media/google.svg.832cb84b.png";